<template>
  <div>
    <div class="mx-auto pa-1 pa-sm-4 auto-width" v-if="step.clip">
      <Audio :step="step" />
    </div>
    <Markdown v-if="step.text" :text="step.text" />
    <div class="mx-auto pa-1 pa-sm-4 auto-width" v-if="step.notes">
      <Score :notes="step.notes" :height="120" />
      <p class="mt-2 mx-auto subtitle-2 blue-grey--text auto-width">
        {{ step.caption }}
      </p>
    </div>
    <div class="mx-auto pa-1 pa-sm-4 auto-width" v-if="step.fretboard">
      <Fretboard
        :notes="step.fretboard.spec"
        :frets="step.fretboard.num_frets"
        :startFret="step.fretboard.start_fret"
      />
      <p class="mt-2 subtitle-2 blue-grey--text">
        {{ step.caption || step.fretboard.root + " " + step.fretboard.name }}
      </p>
    </div>
  </div>
</template>
<script>
import Audio from "@/components/Audio.vue";
import Fretboard from "@/components/Fretboard.vue";
import Markdown from "@/components/Markdown.vue";
import Score from "@/components/Score.vue";

export default {
  name: "LessonStep",
  components: { Audio, Fretboard, Markdown, Score },
  props: {
    step: Object
  }
};
</script>
